export default __webpack_public_path__ + "static/media/board_vs_match.6923e297.png";